export default {
  youtube: "https://www.youtube.com/channel/UCsVLIuW7xx4X2lfnaUO_pyw",
  instagram: "https://www.instagram.com/greenvision.ua/",
  facebook: "https://www.facebook.com/greenvision.ua/",
  telegram: "https://t.me/greenvision_official",
};
